import { Calendar } from "lucide-react";

export default function FloatingCTA() {
  const go = () => {
    const el = document.getElementById("contact");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.location.href = "/#contact";
    }
  };

  return (
    <button
      type="button"
      data-testid="floating-cta"
      onClick={go}
      aria-label="Plan een adviesgesprek"
      title="Plan een adviesgesprek"
      className="fixed z-[45] bottom-5 right-5 md:bottom-6 md:right-6 w-12 h-12 md:w-14 md:h-14 bg-[#1E5BC6] hover:bg-[#1846A8] text-white shadow-xl transition-all duration-300 hover:-translate-y-0.5 flex items-center justify-center"
    >
      <Calendar size={20} strokeWidth={2} />
    </button>
  );
}
